import { AppState } from "store/rootReducer";
import { createSelector } from "reselect";

export const authorizationState = (state: AppState) => state.authorization;

const routerState = (state: AppState) => state.router;

export const getAuthState = createSelector(authorizationState, ({ isAuthorizing, isAuthorized }) => ({
    isAuthorizing,
    isAuthorized,
}));

export const getSearchQuery = createSelector(routerState, ({ location: { search } }) => search);

export const getAuthorizationToken = createSelector(authorizationState, ({ data }) => data?.token || "");

export const getTokensMatSpecId = createSelector(authorizationState, ({ data }) => data?.matSpec || -1);

export const getUserId = createSelector(authorizationState, ({ data }) => data?.userId || -1);

export const getUserName = createSelector(authorizationState, ({ data }) => data?.user);

export const getIsInternalUser = createSelector(authorizationState, ({ data }) => data?.isInternalUser);
